module.exports = __webpack_public_path__ + "static/media/google.e90860b8.png";